import { useCallback, useEffect, useMemo } from "react";
import { useForm, useFormContext, UseFormMethods } from "react-hook-form";
import { useDispatch } from "react-redux";
import { DOCUMENT_TYPES } from "../../../constants/enums/document-types";
import { RANGE_OF_EMPLOYEES } from "../../../constants/enums/range-of-employees";
import { QuotationPopupSubmitForm } from "../../../redux/quotation-popup/actions/default";
import { quotationPopupFormResolver } from "../quotation-popup.schema";
import { QuotationPopupFormModelRaw } from "../types/quotation-popup";

export const useQuotationPopupForm = (): {
    rhForm: UseFormMethods<QuotationPopupFormModelRaw>;
    handleSubmit: (event: any) => Promise<void>;
} => {
    const dispatch = useDispatch();
    const rhForm = useForm<Record<keyof QuotationPopupFormModelRaw, any>>({
        resolver: quotationPopupFormResolver,
        mode: "onChange",
        defaultValues: {
            documentType: DOCUMENT_TYPES.RUC,
            yesNo: false,
            termsAndConditions: false,
            employeesHaveValidAge: false,
            rangeOfEmployees: RANGE_OF_EMPLOYEES.FROM_1_20,
        },
    });
    useEffect(() => {
        rhForm.register("yesNo");
        rhForm.register("employeesHaveValidAge");
        rhForm.register("termsAndConditions");
        rhForm.register("rangeOfEmployees");
    }, []);
    const handleSubmit = useCallback(
        (formValue: QuotationPopupFormModelRaw) => {
            dispatch(
                new QuotationPopupSubmitForm({
                    data: {
                        ...formValue,
                        monthlyAmount: Number(formValue.monthlyAmount),
                    },
                    form: rhForm,
                }).create()
            );
        },
        []
    );
    const rhFormHandleSubmit = useMemo(
        () => rhForm.handleSubmit(handleSubmit),
        []
    );
    return {
        rhForm,
        handleSubmit: rhFormHandleSubmit,
    };
};

export const useQuotationPopupFormContext =
    (): UseFormMethods<QuotationPopupFormModelRaw> => {
        return useFormContext<QuotationPopupFormModelRaw>();
    };
